module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/logoZPAR.dbc44d7f.svg";